export const indicator = {
  availableOnMobile: "Available on mobile",
  schedulingIssue: {
    1: "Planning error (scheduled date after the intervention deadline) ",
    2: "Delay (Scheduled date before today)",
    4: "Intervention delay expired",
  },
  schedulingIssueLabel: {
    1: "Error",
    2: "Delay",
    4: "Expired",
  },
  withoutTemplate: "No associated template",
  assetExceededLifespan: "Exceeded lifespan",
};
